<template>
  <div
    class="podcast-card position-relative mb-4"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <HMFixedAspectRatioContainer aspectRatio="1by1">
      <PodcastThumbnail
        :podcast="podcast"
        :hideOverlay="true"
        :active="podcast.active"
      />
    </HMFixedAspectRatioContainer>
    <div
      class="d-flex mt-3 flex-grow-1 flex-column mr-3"
      :class="{ archived: !podcast.active }"
    >
      <div class="d-flex justify-content-between">
        <div>
          <v-clamp
            autoresize
            :max-lines="2"
            class="podcast-title h4 m-0 media-title mb-2"
          >
            {{ podcast.title }}
          </v-clamp>
        </div>
        <div>
          <HMIconButton
            :icon="['far', 'ellipsis-h']"
            :id="`popover-${podcast.id}`"
          />
          <HMPopover :target="`popover-${podcast.id}`" placement="topleft">
            <HMPopoverMenuItem
              v-if="!podcast.user_left_this_podcast"
              @click="leavePodcast(podcast)"
            >
              {{ $t('PODCASTS.LINK.LEAVE_PODCAST') }}
            </HMPopoverMenuItem>
            <HMPopoverMenuItem v-else @click="rejoinPodcast(podcast)">
              {{ $t('PODCASTS.LINK.REJOIN_PODCAST') }}
            </HMPopoverMenuItem>
          </HMPopover>
        </div>
      </div>
      <div class="d-flex justify-content-start">
        {{
          $tc('PODCASTS.TEXT.EPISODES_VARIANT', podcast.num_episodes, {
            count: podcast.num_episodes,
          })
        }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { errorToMessage } from '@/core/utils/errors';
import { formatObjectForBackend } from '@/core/api/utils/converter';
import { cloneDeep } from 'lodash';
import VClamp from 'vue-clamp';
import { mapGetters } from 'vuex';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';
import PodcastThumbnail from './PodcastThumbnail';
import PodcastMembersModal from './PodcastMembersModal';
import HMDialog from '../common/HMDialog';
import { getStudioURL } from '../../router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioPodcastCard',
  props: {
    podcast: {
      type: Object,
      required: true,
    },
  },
  components: {
    PodcastThumbnail,
    VClamp,
  },
  computed: {
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  methods: {
    async leavePodcast(podcast) {},
    async rejoinPodcast(podcast) {},
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.podcast-card {
  min-width: 256px;

  &:hover {
    .podcast-title {
      color: $coral;
    }
  }
}

.podcast-title {
  max-width: 180px;
  @media screen and (max-width: 768px) {
    max-width: 270px;
  }
}
</style>
